import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, roles }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center" data-testid="auth-loading">
        <div className="label-eyebrow">Loading</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace state={{ from: location }} />;
  if (roles && !roles.includes(user.role)) {
    // Route to their home
    const home =
      user.role === "super_admin" ? "/a/dashboard" :
      user.role === "estate_manager" ? "/m/dashboard" : "/r/dashboard";
    return <Navigate to={home} replace />;
  }
  return children;
}
